import { Native } from "./native";
var Helper = /** @class */ (function () {
    function Helper(systemInfo) {
        this.cachedAvailableSubApps = null;
        this.loaded = false;
        this.systemInfo = systemInfo;
    }
    Helper.prototype.load = function () {
        var _this = this;
        if (this.loaded)
            return Promise.resolve();
        return this.systemInfo.getAppInfo().then(function (appInfo) {
            _this.loaded = true;
            if (appInfo.subApps)
                _this.cachedAvailableSubApps = appInfo.subApps;
        });
    };
    Helper.prototype.isSubAppAvailable = function (subAppInstance) {
        var s = this.isSubAppAvailablePrecise(subAppInstance);
        return s === true || s === null;
    };
    Helper.prototype.isSubAppAvailablePrecise = function (subAppInstance) {
        var prefix;
        if (typeof subAppInstance === 'string') {
            prefix = subAppInstance;
        }
        else {
            prefix = subAppInstance.getPrefix();
        }
        if (this.cachedAvailableSubApps) {
            return this.cachedAvailableSubApps.indexOf(prefix) !== -1;
        }
        return null;
    };
    Helper.getInstance = function (systemInfo) {
        if (systemInfo === void 0) { systemInfo = undefined; }
        var instance = window.nativeHelperInstance;
        if (instance)
            return instance;
        if (typeof systemInfo === undefined) {
            systemInfo = Helper.getNativeModuleInstance(Native.SystemInfo);
        }
        window.nativeHelperInstance = new Helper(systemInfo);
        return window.nativeHelperInstance;
    };
    Helper.getNativeModuleInstance = function (construct) {
        if (typeof window.nativeHelperSubApps === 'undefined')
            window.nativeHelperSubApps = {};
        var subApps = window.nativeHelperSubApps;
        if (typeof subApps['' + construct] === 'undefined') {
            subApps['' + construct] = new construct();
        }
        return subApps['' + construct];
    };
    return Helper;
}());
export { Helper };
//# sourceMappingURL=helper.js.map